import type { ReactElement } from 'react';
import { useContext } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ODSButton, ODSGroup } from 'bc-ods';
import MatchingAccountCard from './MatchingAccountCard';
import {
  FormStepEnum,
  SmartLoginActionsContext,
  SmartLoginStateContext,
} from './context/SmartLoginContextProvider';

const messages = defineMessages({
  heading: {
    id: 'SSOAccountDiscovered.heading',
    defaultMessage: 'Account found',
  },
  foundExistingAccount: {
    id: 'SSOAccountDiscovered.foundExistingAccount',
    defaultMessage:
      'We found an existing account that matches your SSO email. Is this your account?',
  },
  thisIsMyAccount: {
    id: 'SSOAccountDiscovered.thisIsMyAccount',
    defaultMessage: 'This is my account',
  },
  linkDifferentAccount: {
    id: 'SSOAccountDiscovered.linkDifferentAccount',
    defaultMessage: 'Link to a different account',
  },
});

function SSOAccountDiscovered(): ReactElement {
  const { profile, discoveredAccountDetails } = useContext(SmartLoginStateContext);
  const { setFormStep } = useContext(SmartLoginActionsContext);

  return (
    <ODSGroup stacked spacing="xl">
      <div>
        <h5>
          <FormattedMessage {...messages.heading} />
        </h5>
        <p className="text-secondary mb-0">
          <FormattedMessage {...messages.foundExistingAccount} />
        </p>
      </div>
      <MatchingAccountCard
        profile={profile}
        discoveredAccountDetails={discoveredAccountDetails}
      />
      <ODSGroup stacked>
        <ODSButton
          cta
          fullWidth
          onClick={() => setFormStep(FormStepEnum.SSOVerifyExistingAccount)}
          data-testid="button-this-is-my-account"
        >
          <FormattedMessage {...messages.thisIsMyAccount} />
        </ODSButton>
        <ODSButton
          fullWidth
          onClick={() => setFormStep(FormStepEnum.SSOLinkAccount)}
          data-testid="button-link-different-account"
          quiet
          css={(theme) => ({ color: theme.colors.primary, textDecoration: 'underline' })}
        >
          <FormattedMessage {...messages.linkDifferentAccount} />
        </ODSButton>
      </ODSGroup>
    </ODSGroup>
  );
}

export default SSOAccountDiscovered;
